'use strict';
const Alerts = require('lib/alerts');

var RowEditView = require('commons/views/RowEdit');
var template    = require('../../templates/employee/YearlyTotalRow.ejs');
var log         = require('lib/log')('yearly-total-row-view');

module.exports = RowEditView.extend({
    tagName:   'tr',
    className: 'item',

    events: function() {
        return Object.assign({}, RowEditView.prototype.events() || {}, {
            'focus input':                 'selectInputContent',
            'change input.js-ext-monthly': 'updateMonthlyAmount',
            'change input.js-ext-amount':  'updateAmount'
        });
    },

    initialize: function(options) {
        const item = this.model.getPayrollItem();

        this.options = _.defaults(options || {}, {
            current:          true,
            template:         template,
            tabIndexOffset:   0,
            tabIndexStepping: 1,
            months:           [],
            templateExtra:    {},
            stop:             0,
        });
        this.options.templateExtra = _.defaults(this.options.templateExtra, {
            months:  this.options.months,
            current: this.options.current,
            deletable: (
                !['base', 'mtd', 'epf', 'socso'].includes(item.get('type')) ||
                item.get('subtype') === 'custom' ||
                item.get('isUnit')
            )
        });

        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        if (this.options.current) {
            // this.model.on('change:monthly', this.propagateMonthly, this);
            this.model.on('change:monthly', this.updateAmountFromMonthly, this);
            this.model.on('change:monthly', this.renderMonthly, this);
        } else {
            /*
            this.model.on(
                'change:prevEmploymentMonthly',
                this.propagateMonthly,
                this
            );*/
            this.model.on(
                'change:prevEmploymentMonthly',
                this.updateAmountFromMonthly,
                this
            );
            this.model.on(
                'change:prevEmploymentMonthly',
                this.renderMonthly,
                this
            );
        }

        return RowEditView.prototype.bindHandlers.apply(this, arguments);
    },

    render: function() {
        RowEditView.prototype.render.apply(this, arguments);

        this.setTabIndex(
            this.options.tabIndexOffset,
            this.options.tabIndexStepping
        );
    },

    selectInputContent: function(ev) {
        this.$(ev.currentTarget).select();
    },

    updateMonthlyAmount: function(ev) {
        var $input  = this.$(ev.currentTarget);
        var attr    = this.options.current ?
            'monthly' : 'prevEmploymentMonthly';
        var month   = parseInt($input.attr('name').replace('monthly-', ''), 10);
        var monthly = _.clone(this.model.get(attr)) || [];
        var value   = this.getInputValue($input);
        if (_.isNaN(parseFloat(value))) {
            value = 0;
        }
        monthly[month] = value;

        log.info('Updating', attr, 'with', monthly);

        this.model.set(attr, monthly);

        return this;
    },

    updateAmount: function(ev) {
        var $input = this.$(ev.currentTarget);
        var attr   = this.options.current ?
            'amount' : 'prevEmploymentAmount';
        var value = this.getInputValue($input);
        if (_.isNaN(parseFloat(value))) {
            value = 0;
        }
        log.info('Updating', attr, 'with', value);

        this.model.set(attr, value);

        return this;
    },

    updateAmountFromMonthly: function(model) {
        if (model.changed.monthly) {
            this.model.set({
                amount: this.model.getMonthlySum({current: true})
            });

            this.renderAmount(this.model);
        }

        if (model.changed.prevEmploymentMonthly) {
            this.model.set({
                prevEmploymentAmount: this.model.getMonthlySum({current: false})
            });

            this.renderAmount(this.model);
        }
    },

    renderAmount: function(model) {
        var attr = this.options.current ? 'amount' : 'prevEmploymentAmount';
        this.$('[name="amount"]').val((model.get(attr) || 0).toFixed(2));
    },

    renderMonthly: function(model) {
        var attr = this.options.current ? 'monthly' : 'prevEmploymentMonthly';
        var monthly = model.get(attr) || [];

        monthly.forEach((amount, idx) => {
            this.$('[name="monthly-' + idx + '"].js-ext-monthly').val(
                (amount || 0).toFixed(2)
            );
        });
    },

    /**
     * 20200604 disable automatic propogating YTD values.
     * ticket: https://jibbletech.atlassian.net/browse/PPD-1002
    propagateMonthly: function(model, value) {
        var attr = this.options.current ? 'monthly' : 'prevEmploymentMonthly';

        var previous = model.previous(attr) || [];
        var months   = this.options.months || [];
        var first    = (_.first(months) || {}).index;
        var month    = first;
        var amounts  = _.filter(value, function(amount, i) {
            if (i < month) {
                return false;
            }

            if (month === first && amount !== previous[i]) {
                month = i + 1;
            }

            return (amount !== previous[i]);
        });
        var amount   = _.first(amounts);
        var itemType = model.getPayrollItem().get('type');
        var stop = this.options.stop.index;

        log.info('Propagating changes in monthly value in', attr);

        if (this.options.current && !model.changed.monthly) {
            log.info('Ignoring changes to prevEmploymentMonthly');
            return;
        }
        if (!this.options.current && !model.changed.prevEmploymentMonthly) {
            log.info('Ignoring changes to monthly');
            return;
        }
        if (!_.contains(['base', 'epf', 'socso', 'mtd'], itemType)) {
            log.info('Wrong item type. Stop propagation.');
            return;
        }
        if (_.compact(amounts).length > 1) {
            log.info('Too many changes. Stop propagation.');
            return;
        }
        if (!amount) {
            log.info('Only falsy values. Stop propagation.');
            return;
        }
        if (month > _.last(months).index) {
            log.info('Dont propagate last value. Stop propagation.');
            return;
        }
        if (_.compact(value).length > month) {
            log.info('There are other values. Stop propagation.');
            return;
        }

        _.each(months, function(m) {
            if (m.index < month || m.index > stop) {
                return;
            }

            value[m.index] = amount;
        });

        log.info('Storing propagated values', attr, month, value);
        this.model.set(attr, value);
    },
    */

    destroyModel: function() {
        var text = 'You will be able to add this item back, but all amounts ' +
            'will be lost';

        if (!this.options.current && this.model.get('amount')) {
            text = 'You also have current employment data on this item and ' +
                'deleting it will clear everything.';
        }

        if (this.options.current && this.model.get('prevEmploymentAmount')) {
            text = 'You also have previous employment data on this item and ' +
                'deleting it will clear everything.';
        }

        Alerts.show('dangerConfirm', {text: text})
            .then(() => {
                this.model.destroy().then(
                    () => this.remove(),
                    err => Alerts.show('criticalError', err)
                );
            });
    },

    setTabIndex: function(offset, stepping) {
        var $inputs = this.$('input.js-ext-monthly');

        this.options.tabIndexOffset = offset;
        this.options.tabIndexStepping = stepping;

        $inputs.each(function(i, input) {
            var $input = $(input);

            $input.attr('tabIndex', offset + (i * stepping));
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/YearlyTotalRow.js